/**
 * Ein Objekt klonen.
 * 
 * @param obj Objekt das geclont werden soll
 * @returns Ein neues Objekt mit denselben Eigenschaften
 */
const clone = <T>(obj: T):T => 
  JSON.parse(JSON.stringify((obj as unknown)))

export default clone